// App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthControls from './components/AuthControls';
import Home         from './pages/Home';
import Chat         from './pages/Chat';
import History      from './pages/History';
import HistoryDetail from './pages/HistoryDetail';

function App() {
  return (
    <Router>
      <AuthControls />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chat/:id" element={<Chat />} />
        <Route path="/history"        element={<History />} />
        <Route path="/history/:chatId" element={<HistoryDetail />} />
      </Routes>
    </Router>
  );
}

export default App;
